// extracted by mini-css-extract-plugin
module.exports = {"main":"Companies_main__aPXRA","companies__list":"Companies_companies__list__SIO_5","companies__card":"Companies_companies__card__6xt_B"};